/**
 * Centralized error handlers for HTTP status codes.
 * App registers callbacks; no UI or DOM here.
 * 401: logout, clear storage, redirect to login (optional message e.g. session ended)
 * 403: show popup "access denied", "Go to Home"
 * 404: quiet inline message (no popup, no redirect)
 */
export interface ApiErrorHandlers {
  /** Called when auth is invalid. Message is set when session ended (e.g. refresh failed). */
  onUnauthorized?: (message?: string) => void;
  onForbidden?: () => void;
  onNotFound?: () => void;
}

let handlers: ApiErrorHandlers = {};

export function setApiErrorHandlers(h: ApiErrorHandlers): void {
  handlers = { ...handlers, ...h };
}

export function getApiErrorHandlers(): ApiErrorHandlers {
  return handlers;
}

export function clearApiErrorHandlers(): void {
  handlers = {};
}
